import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router';
import { Zap, Menu, X } from 'lucide-react';
import './Navbar.css';

const links = [
  { to: '/', label: 'Home' },
  { to: '/segp', label: 'SEGP' },
  { to: '/#problem', label: 'Problem' },
  { to: '/#solution', label: 'Solution' },
  { to: '/#architecture', label: 'Architecture' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location]);

  const handleClick = (e, to) => {
    if (!to.startsWith('/#')) return;
    e.preventDefault();
    const id = to.replace('/#', '');
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else if (location.pathname !== '/') {
      window.location.href = to;
    }
  };

  const isActive = (to) => {
    if (to.startsWith('/#')) return false;
    return location.pathname === to;
  };

  return (
    <nav className="navbar">
      <Link to="/" className="logo">
        <Zap className="logoIcon" />
        KERAUNOS AI
      </Link>

      <div className={`navLinks ${open ? 'open' : ''}`}>
        {links.map((link) => (
          <Link
            key={link.label}
            to={link.to}
            onClick={(e) => handleClick(e, link.to)}
            className={isActive(link.to) ? 'active' : ''}
          >
            {link.label}
          </Link>
        ))}
        <a href="mailto:office@keraunos-ai.com" className="cta">Contact</a>
      </div>

      <button className="mobileToggle" onClick={() => setOpen(!open)} aria-label="Toggle menu">
        {open ? <X /> : <Menu />}
      </button>
    </nav>
  );
}
